import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData, setRandomValues, paginate, filter, sort } from './utils';
const selectableData = getData().map(i => {
    i.selected = false;
    return i;
});
let DemoKitchenSink = class DemoKitchenSink extends LitElement {
    constructor() {
        super(...arguments);
        this.data = selectableData;
        this.currentDetail = null;
        this.filteredList = [];
        this.sortType = 'none';
        this.search = '';
        this.currentPage = 0;
        this.pageSize = 10;
        this.pageCount = 1;
        this.idFilterOpen = false;
        this.allSelected = false;
    }
    render() {
        var _a, _b, _c, _d, _e;
        return html `
      <cds-grid>
        <cds-grid-column resizable="false" width="60">
          <cds-checkbox>
            <label><span style="display: none">select all</span></label>
            <input type="checkbox" .checked=${this.allSelected} @change=${(e) => this.selectAll(e)} />
          </cds-checkbox>
        </cds-grid-column>
        <cds-grid-column .sort=${this.sortType} @sortChange=${e => this.sortType = e.detail}>
          Stock
          <cds-inline-button id="id-filter" @click=${() => this.idFilterOpen = true} aria-label="filter column" cds-layout="align:right">
            <cds-icon shape="filter"></cds-icon>
          </cds-inline-button>
          <cds-dropdown ?hidden=${!this.idFilterOpen} @hiddenChange=${() => this.idFilterOpen = false} anchor="#id-filter">
            <cds-datalist>
              <label cds-layout="display:screen-reader-only">search</label>
              <input type="text" placeholder="Search" @input=${e => this.search = e.target.value} />
              <datalist>
                ${this.data.map(entry => html `<option value="${entry.id}"></option>`)}
              </datalist>
            </cds-datalist>
          </cds-dropdown>
        </cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.filteredList.map(entry => html `
          <cds-grid-row .select=${entry.selected}>
            <cds-grid-cell>
              <cds-checkbox>
                <label cds-layout="display:screen-reader-only">Select ${entry.id}</label>
                <input type="checkbox" .checked=${this.allSelected} value=${entry.id} @click=${(e) => this.select(entry, e.target.checked)} />
              </cds-checkbox>
              <cds-inline-button id="${entry.id}-detail" aria-label="view ${entry.id} details" @click=${() => this.showDetail(entry.id)}>
                <cds-icon shape="angle" direction="right"></cds-icon>
              </cds-inline-button>
            </cds-grid-cell>
            <cds-grid-cell>
              ${entry.id}
            </cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer>
          <cds-pagination>
            <span style="margin-right: auto;">${this.data.filter(i => i.selected).length} selected</span>
            <cds-select control-width="shrink">
              <label cds-layout="display:screen-reader-only">per page</label>
              <select @input=${e => this.pageSize = e.target.value} style="min-width: 46px">
                <option value="5">5</option>
                <option value="10" selected>10</option>
                <option value="15">15</option>
                <option value="25">25</option>
              </select>
            </cds-select>
            <cds-pagination-button ?disabled=${this.currentPage === 0} action="first" @click=${this.firstPage}></cds-pagination-button>
            <cds-pagination-button ?disabled=${this.currentPage === 0} action="prev" @click=${this.prevPage}></cds-pagination-button>
            <input type="number" @input=${this.setPage} .value=${this.currentPage + 1} min="1" max=${this.pageCount} aria-label="page number" /> / ${this.pageCount}
            <cds-pagination-button ?disabled=${this.currentPage === this.pageCount - 1} action="next" @click=${this.nextPage}></cds-pagination-button>
            <cds-pagination-button ?disabled=${this.currentPage === this.pageCount - 1} action="last" @click=${this.lastPage}></cds-pagination-button>
          </cds-pagination>
        </cds-grid-footer>
        <cds-grid-detail ?hidden=${!this.currentDetail} anchor="${(_a = this.currentDetail) === null || _a === void 0 ? void 0 : _a.id}-detail" @closeChange=${this.closeDetail}>
          <h2>${(_b = this.currentDetail) === null || _b === void 0 ? void 0 : _b.id}</h2>
          <p>Average: $${(_c = this.currentDetail) === null || _c === void 0 ? void 0 : _c.average}</p>
          <p>Current: $${(_d = this.currentDetail) === null || _d === void 0 ? void 0 : _d.value}</p>
          <p>About: ${(_e = this.currentDetail) === null || _e === void 0 ? void 0 : _e.about}</p>
        </cds-grid-detail>
      </cds-grid>
    `;
    }
    showDetail(id) {
        this.currentDetail = this.data.find(i => i.id === id);
    }
    closeDetail() {
        this.currentDetail = null;
    }
    select(entry, checked) {
        this.data.find(i => i.id === entry.id).selected = checked;
        this.allSelected = !this.data.find(i => !i.selected);
        this.updateList();
    }
    selectAll(e) {
        this.allSelected = e.target.checked;
        this.data.forEach(i => i.selected = e.target.checked);
        this.updateList();
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateList();
        setInterval(() => this.filteredList = setRandomValues(this.filteredList), 1000);
    }
    updated(props) {
        super.updated(props);
        if ((props.has('currentPage') && props.get('currentPage') !== this.currentPage) ||
            (props.has('search') && props.get('search') !== this.search) ||
            (props.has('sortType') && props.get('sortType') !== this.sortType) ||
            (props.has('pageSize') && props.get('pageSize') !== this.pageSize)) {
            this.updateList();
        }
        if (props.has('search') && props.get('search') !== this.search) {
            this.firstPage();
        }
    }
    updateList() {
        var _a;
        let list = sort(filter([...this.data], 'id', this.search), 'id', this.sortType);
        this.pageCount = Math.ceil(list.length / this.pageSize);
        this.filteredList = (_a = paginate(list, this.pageSize)[this.currentPage]) !== null && _a !== void 0 ? _a : [];
    }
    setPage(event) {
        this.currentPage = parseInt(event.target.value) - 1;
    }
    nextPage() {
        if (this.currentPage <= this.pageCount) {
            this.currentPage++;
        }
    }
    prevPage() {
        if (this.currentPage > 0) {
            this.currentPage--;
        }
    }
    firstPage() {
        this.currentPage = 0;
    }
    lastPage() {
        this.currentPage = Math.ceil(this.data.length / this.pageSize) - 1;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "currentDetail", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "filteredList", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "sortType", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "search", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "currentPage", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "pageSize", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "pageCount", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "idFilterOpen", void 0);
__decorate([
    internalProperty()
], DemoKitchenSink.prototype, "allSelected", void 0);
DemoKitchenSink = __decorate([
    customElement('demo-kitchen-sink')
], DemoKitchenSink);
export { DemoKitchenSink };
//# sourceMappingURL=demo.kitchen-sink.js.map